import { heydayPath, navigateToHeydayPage, pageFromPathname, subscribeToHeydayLocation } from '../../config/heydayRoutes';
import type { WorkflowRoutePage, WorkflowRoutePort } from '../../features/workflow/public';

function isWorkflowRoutePage(page: string | undefined): page is WorkflowRoutePage {
  return page === 'my-workflows' || page === 'my-workflow-requests' || page === 'workflow-requests' || page === 'my-tasks' || page === 'inbox';
}

export const workflowRouteAdapter: WorkflowRoutePort = {
  path: heydayPath,
  navigate: navigateToHeydayPage,
  currentPage() {
    const page = pageFromPathname(window.location.pathname);
    return isWorkflowRoutePage(page) ? page : undefined;
  },
  subscribe: subscribeToHeydayLocation,
};
